export const notificationBanner = (theme) => {
    return {
        base: {
            padding: theme.space?.space4,
            paddingLeft: theme.space?.space16,
        },
        variants: {
            success: {
                backgroundColor: theme.colors?.component?.utility?.green[100],
            },
            warning: {
                backgroundColor: theme.colors?.component?.utility?.yellow[100],
            },
            error: {
                backgroundColor: theme.colors?.component?.utility?.red[100],
            },
            info: {
                backgroundColor: theme.colors?.component?.utility?.blue[100],
            },
        },
    };
};
//# sourceMappingURL=notification-banner.js.map